<ndt-call-logs-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [callDetailsPrivileges]="callDetailsPrivileges$ | async"
   [isSystemUser]="isSystemUser$ | async"
   (loadMore)="onLoadMore()"
   (openDialog)="onOpenDialog($event)"
   (listen)="onListen($event)"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-call-logs-register-view>
